import { supabase } from '../../../services/supabaseClient';

const TABLE = 'bianca_realestate_imovel_corretores';
const TABLE_IMOVEIS = 'mf_imoveis';
const TABLE_CORRETORES = 'bianca_realestate_corretores';

export async function listImoveisImobiliaria() {
  const { data, error } = await supabase
    .from(TABLE_IMOVEIS)
    .select('id, titulo, tipo, status, preco, preco_aluguel, quartos, bairro, cidade, condominio, imagens')
    .is('corretor_id', null)
    .eq('status', 'publicado')
    .eq('status_aprovacao', 'aprovado')
    .order('updated_at', { ascending: false });

  if (error) {
    console.error('[listImoveisImobiliaria]', error);
    return [];
  }
  return data || [];
}

export async function listVinculosDoCorretor(corretorId) {
  if (!corretorId) return [];
  const { data, error } = await supabase
    .from(TABLE)
    .select('id, imovel_id, status, motivo_rejeicao, solicitado_em')
    .eq('corretor_id', corretorId);

  if (error) {
    console.error('[listVinculosDoCorretor]', error);
    return [];
  }
  return data || [];
}

export async function listImoveisVinculadosAprovados(corretorId) {
  if (!corretorId) return [];
  const { data: vinculos, error } = await supabase
    .from(TABLE)
    .select('imovel_id')
    .eq('corretor_id', corretorId)
    .eq('status', 'aprovado');

  if (error || !vinculos?.length) return [];

  const ids = vinculos.map(v => v.imovel_id);
  const { data: imoveis } = await supabase
    .from(TABLE_IMOVEIS)
    .select('id, titulo, tipo, status, status_aprovacao, motivo_rejeicao, preco, preco_aluguel, quartos, bairro, cidade, condominio, imagens, created_at, updated_at')
    .in('id', ids)
    .eq('status', 'publicado')
    .order('updated_at', { ascending: false });

  return (imoveis || []).map(i => ({ ...i, _vinculoMF: true }));
}

export async function solicitarAcesso(imovelId, corretorId) {
  const { data, error } = await supabase
    .from(TABLE)
    .insert({
      imovel_id: imovelId,
      corretor_id: corretorId,
      status: 'pendente',
    })
    .select()
    .single();

  if (error) {
    if (error.code === '23505') throw new Error('Você já solicitou acesso a este imóvel.');
    throw error;
  }
  return data;
}

export async function listSolicitacoes(statusFilter) {
  let query = supabase
    .from(TABLE)
    .select(`
      id, status, motivo_rejeicao, solicitado_em, respondido_em, respondido_por,
      imovel_id, corretor_id
    `)
    .order('solicitado_em', { ascending: false });

  if (statusFilter) query = query.eq('status', statusFilter);

  const { data, error } = await query;
  if (error) {
    console.error('[listSolicitacoes]', error);
    return [];
  }

  if (!data?.length) return [];

  const imovelIds = [...new Set(data.map(d => d.imovel_id))];
  const corretorIds = [...new Set(data.map(d => d.corretor_id))];

  const [imoveisRes, corretoresRes] = await Promise.all([
    supabase.from(TABLE_IMOVEIS).select('id, titulo, bairro, cidade, imagens').in('id', imovelIds),
    supabase.from(TABLE_CORRETORES).select('id, nome, email, creci, creci_uf').in('id', corretorIds),
  ]);

  const imoveisMap = Object.fromEntries((imoveisRes.data || []).map(i => [i.id, i]));
  const corretoresMap = Object.fromEntries((corretoresRes.data || []).map(c => [c.id, c]));

  return data.map(d => ({
    ...d,
    imovel: imoveisMap[d.imovel_id] || null,
    corretor: corretoresMap[d.corretor_id] || null,
  }));
}

export async function aprovarVinculo(vinculoId, aprovadoPor) {
  const { error } = await supabase
    .from(TABLE)
    .update({
      status: 'aprovado',
      motivo_rejeicao: null,
      respondido_em: new Date().toISOString(),
      respondido_por: aprovadoPor,
    })
    .eq('id', vinculoId);

  if (error) throw error;
}

export async function rejeitarVinculo(vinculoId, motivo, aprovadoPor) {
  const { error } = await supabase
    .from(TABLE)
    .update({
      status: 'rejeitado',
      motivo_rejeicao: motivo,
      respondido_em: new Date().toISOString(),
      respondido_por: aprovadoPor,
    })
    .eq('id', vinculoId);

  if (error) throw error;
}

export async function getCorretoresDoImovel(imovelId) {
  if (!imovelId) return [];
  const { data, error } = await supabase
    .from(TABLE)
    .select('corretor_id')
    .eq('imovel_id', imovelId)
    .eq('status', 'aprovado');

  if (error || !data?.length) return [];

  const ids = data.map(d => d.corretor_id);
  const { data: corretores } = await supabase
    .from(TABLE_CORRETORES)
    .select('id, nome, email, telefone, creci, creci_uf, foto_url')
    .in('id', ids);

  return corretores || [];
}

export async function sortearCorretor(imovelId) {
  const corretores = await getCorretoresDoImovel(imovelId);
  if (!corretores.length) return null;
  return corretores[Math.floor(Math.random() * corretores.length)];
}
